import axios from 'axios';

export const UsersService = {
  getUsersService: async () => {
    try {
      const response = await axios.get('/api/users');
      if (response.success && response.data) {
        return response.data.users;
      }
      return [];
    } catch (error) {
      console.error('Error al obtener usuarios:', error);
      return [];
    }
  },

  getUserService: async (id) => {
    try {
      const response = await axios.get(`/api/users/${id}`);
      if (response.success && response.data) {
        return response.data.user;
      }
      return null;
    } catch (error) {
      console.error(`Error al obtener usuario con ID ${id}:`, error);
      return null;
    }
  },

  createUserService: async (userData) => {
    try {
      const response = await axios.post('/api/users', userData);
      if (response.success && response.data) {
        return response.data.user;
      }
      return null;
    } catch (error) {
      console.error('Error al crear usuario:', error);
      throw error;
    }
  },

  updateUserService: async (userData) => {
    try {
      const response = await axios.put(`/api/users/${userData.id}`, userData);
      if (response.success && response.data) {
        return response.data.user;
      }
      return null;
    } catch (error) {
      console.error(`Error al actualizar usuario con ID ${userData.id}:`, error);
      throw error;
    }
  },

  deleteUserService: async (id) => {
    try {
      const response = await axios.delete(`/api/users/${id}`);
      return response.success;
    } catch (error) {
      console.error(`Error al eliminar usuario con ID ${id}:`, error);
      throw error;
    }
  },

  resetPasswordService: async (id) => {
    try {
      const response = await axios.put(`/api/users/${id}/reset-password`);
      if (response.success && response.data && response.data.newPassword) {
        return response.data.newPassword;
      }
      return null;
    } catch (error) {
      console.error(`Error al resetear password del usuario con ID ${id}:`, error);
      throw error;
    }
  },

  changeMyPassword: async (passwordData) => {
    try {
      const response = await axios.put('/api/account/password', passwordData);
      return Boolean(response.data.changed);
    } catch (error) {
      console.error('Error al cambiar contraseña:', error);
      throw error;
    }
  }
}; 